const genericInputNullOption = {
  value: null, label: 'N/A'
};
  
const useValidationLineItemMetaOptions = function({ lineItem, fieldConfiguration, newMode }) {
  const validationTypeOptions = [
    genericInputNullOption,
    ...fieldConfiguration.lineItem.validation.type.options
  ];


  const productNameOptions = [genericInputNullOption];
  const savedProductName = lineItem.fields.validation.value?.fields.product_name.value;
  if (!newMode && savedProductName) {
    productNameOptions.push({ value: savedProductName, label: savedProductName });
  } else {
    productNameOptions.push(
      ...fieldConfiguration.lineItem.product_names.map(productName => (
        { value: productName, label: productName }
      ))
    );
  }

  return {
    validationTypeOptions,
    productNameOptions
  };
};

export default useValidationLineItemMetaOptions;
